<div
	class="crypto-card"
	(click)="handleCardClick()"
	[ngClass]="{
		negative: healthIndicator === marginHealthIndicator.Low
	}">
	<div class="flex justify-between">
		<div class="flex items-center">
			<img [src]="getLogoUrl(marginPosition()?.asset.logos)" alt="" class="crypto-logo" #img />
			<div class="flex flex-col">
				<h6 class="crypto-name font-size-15 mb-0">{{ marginPosition()?.asset.name }}</h6>
				<p class="crypto-owned font-size-12">
					{{
						marginPosition().assetPosition.value
							| tradable_precision_symbol
								: {
										id: tradableId,
										ignorePrecision: true,
										customPrecision: marginPosition().assetPosition.precision
								  }
					}}
				</p>
			</div>
			<div class="leverage font-size-11">
				{{ marginPosition()?.leverage.value | toFixed: marginPosition()?.leverage.precision : true }}x
			</div>
		</div>
		<div class="flex flex-col items-end">
			<span
				class="price-change font-size-11"
				[ngClass]="{
					positive: +marginPosition().performancePercentage.value >= 0,
					negative: +marginPosition().performancePercentage.value < 0
				}">
				@if (+marginPosition().performancePercentage.value >= 0) {
					<svg-inline src="assets/images/icons/positive-indicator.svg" alt="" />
				} @else {
					<svg-inline src="assets/images/icons/negative-indicator.svg" alt="" />
				}
				{{ marginPosition().performancePercentage.value | hideNumberPrefix | percent_precision: 2 : false }}
			</span>
			<span class="font-size-15">{{
				marginPosition().fiatPosition.value
					| fiat_precision_symbol
						: {
								id: defaultFiat.getId(),
								customPrecision: marginPosition().fiatPosition.precision,
								symbol: true
						  }
			}}</span>
		</div>
	</div>
	<div class="progress-bar">
		<position-line-indicator
			[healthIndicator]="healthIndicator"
			[marginLevel]="+marginPosition().marginLevel.current.value"
			[marginMinimum]="+marginPosition().marginLevel.minimum.value"
			[marginMaximum]="+marginPosition().marginLevel.maximum.value"
			[healthThreshold]="{
				high: marginPosition().marginLevel.highHealthThreshold,
				low: marginPosition().marginLevel.lowHealthThreshold
			}" />
		<div
			class="progress"
			[ngClass]="{
				green: healthIndicator === marginHealthIndicator.High,
				yellow: healthIndicator === marginHealthIndicator.Medium,
				red: healthIndicator === marginHealthIndicator.Low
			}"
			[style.width.%]="progressBarValue() * 100"></div>
	</div>
	<div class="price-details font-size-12 flex justify-between">
		<span
			[ngClass]="{
				negative: healthIndicator === marginHealthIndicator.Low
			}">
			{{ "liquidation_price_short" | translate }}:
			{{
				marginPosition().liquidationPrice.value
					| fiat_precision_symbol
						: {
								id: defaultFiat.getId(),
								currencies: [defaultFiat],
								customPrecision: marginPosition().liquidationPrice.precision,
								symbol: true
						  }
			}}
		</span>
		<span>
			{{ marginPosition()?.asset?.symbol }}:
			{{
				marginPosition()?.asset.price.value
					| fiat_precision_symbol
						: {
								id: defaultFiat.getId(),
								currencies: [defaultFiat],
								customPrecision: marginPosition().asset.price.precision,
								symbol: true
						  }
			}}
		</span>
	</div>
	<div class="action-buttons flex item">
		<button
			(click)="addToPosition($event)"
			[disabled]="(canAddPosition$ | async) === false"
			[class.disabled]="(canAddPosition$ | async) === false">
			{{ "add_to_position" | translate }}
		</button>
		<button
			(click)="closePosition($event)"
			[disabled]="(canClosePosition$ | async) === false"
			[class.disabled]="(canClosePosition$ | async) === false">
			{{ "close_position" | translate }}
		</button>
	</div>
</div>
